export default {
  sysTitle: "CS Energy system",
  sysMenu: "System",
  currentPosition: "Current Position",
  operatorId: "Operator Code",
  oprName: "Name of operator",
  tips: "Tips",
  isDelete: "Are You Sure You Want to Delete",
  deleteSuccess: "Successfully Deleted",
  updateSuccess: "Successfully Update",
  addSuccess: "Add Successfully",
  all: "All",
  operation: "Operation",
  dl: "Quantity of electricity",
  eleFee: "Electricity Fees",
  serverFee: "Service Fees",
  delayFee: "Delay Fee",
  totalAmount: "Total Amount",
  yuan: "Yuan",
  kWh: "KWh",
  unitOrder: "Single",
  ac: "AC",
  dc: "DC",
  confirm: "Confirm",
  noData: "No Data",
  allCity: "All Cities",
  chargingStation: "Charging Station",
  merchant: "Merchant",
  operator: "Operator",
  chargingPile: "Charging Pile",
  year: "Year",
  month: "Month",
  day: "Day",
  timeType: "Time Type",
  regularText: "Regular",
  irregular: "Irregular",
  disabled: "Disabled",
  operationSucess: "Operation Sucess",
  saveSucess: "Successfully Save",
  exportSuccess: "Import Succeeded",
  allSelect: "All Select",
  toExamine: "To Examine",
  invalid: "Invalid",
  remark: "Remark",
  nothing: "Nothing",
  error: "Error",
  connectionFailure: "Connection Failure",
  notSupport: "Your browser does not support",
  keyword: "Keyword",
  reviewingMultipleRechargesForOneCard:
    "Reviewing multiple recharges for one card",
  loadMore: "Load More",
  pleaseSelect: "Please Select",
  startSNPl: "Please enter start SN",
  endSNPl: "Please enter the end SN",
  must12Digits: "Must be 12 digits",
  menuOperationAuthority: "Menu operation authority",
  audit: {
    approvalStatus: "Approval Status",
    userName: "Username",
    phoneNo: "Phone Number",
    applyTime: "Application Time",
    applyReason: "Reason for application",
    applyStatusDesc: "Approval Status",
    auditTime: "Audit Time",
    action: "Operate"
  },
  unitText: {
    pen: "Pen",
    yuan: "Yuan",
    hours: "Hours",
    people: "People",
    seat: "Seat",
    year: "Year",
    month: "Month",
    day: "Day",
    ton: "Ton",
    second: "Second",
    full: "Full",
    reduce: "Reduce",
    give: "Give",
    zhang: "Zhang",
    individual: "Individual"
  },
  formText: {
    startTime: "StartTime",
    endTime: "EndTime",
    export: "Export",
    exportLoading: "Loading...",
    exportNumber: "Number of exports",
    exportPl: "The number of exports cannot be less than or equal to 0",
    exportError: "Export error or timeout",
    allCity: "All City",
    selectGun: "Charging Gun",
    selectMch: "Merchant",
    selectSite: "Charging Station",
    selectPile: "Charging Pile",
    selectTime: "Choose the time",
    selectTimePl: "Please select the time",
    selectOper: "Operators",
    downloadForm: "Download Form",
    intTips: "Number",
    beginTimeTips: "Please select start time",
    endTimeTips: "Please select end time",
    import: "Import",
    selectProvince: "Please select Province",
    selectCity: "Please select a city",
    selectArea: "Please select area",
    subSuccess: "Operation Successful",
    goBack: "Go Back",
    timeNull: "Please select a time",
    timeMax: "The start time cannot exceed the end time",
    time24: "24 Hours",
    time7: "7 Days",
    time30: "30 Days",
    timeCustom: "Custom",
    uploadError: "Please upload the following file types:",
    copySuccess: "Copy Successfully",
    loginTimeOut: "Login expired, please log in again"
  },
  directCurrent: "DC",
  alternatingCurrent: "AC",
  gunStatus: "Gun Status",
  gunStatusObj: {
    onLine: "On Line",
    offLine: "Off Line",
    free: "Free",
    connected: "Connected",
    charging: "Charging",
    full: "Full",
    trouble: "Trouble",
    disabled: "Disabled",
    booked: "Booked"
  },
  search: "Search",
  updata: "Edit",
  update: "Edit",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  allDel: "Batch Deletion",
  close: "Close",
  save: "Save",
  refresh: "Refresh",
  back: "Go Back",
  export: "Export",
  import: "Import",
  submit: "Submit",
  cancel: "Cancel",
  details: "Details",
  copy: "Copy",
  regular: {
    name: "Name",
    please: "Please Input ",
    pleaseSelect: "Please Select",
    max: " No more than ",
    maxText: " characters",
    min: "Not less than",
    numberABC: "It can only consist of numbers or letters",
    numberABCs: "It can only be composed of numbers, letters and underscores",
    tel: "Please enter the mobile number or the phone number, 6-15 digits",
    phone: "Please enter the phone number",
    phonePl: "Please input mobile phone number",
    phonePl11: "Please enter the 11 digit mobile phone number",
    phoneError: "Please input the correct mobile phone number",
    int: "It can only be an integer number",
    maxInput: "Maximum Input",
    minInput: "Minimum Input",
    unit: "",
    maxNum: "Cannot be greater than",
    minNum: "Cannot be less than",
    money: "amount of money",
    towDecimal: "Keep up to two decimal places",
    email: "Please input email",
    emailPl: "Mailbox cannot exceed",
    emailError: "Please fill in the correct email"
  },
  login: {
    loginTitle: "CS Energy system",
    userName: "User Name",
    password: "Password",
    loginBtn: "Sign In",
    userNamePl: "Enter one user name",
    passwordPl: "Please input a password",
    passwordError: "Please enter a password with more than 6 digits"
  },
  role: {
    roleList: "Role List",
    autoMenu: "Menu",
    autoConfig: "Configure Permissions",
    roleName: "Chinese RoleName",
    thRoleName: "RoleName",
    enRoleName: "English RoleName",
    roleType: "Role Type",
    roleDesc: "Remarks",
    createUserName: "Creater",
    createTime: "Creation Time",
    modifyTime: "Update Time",
    addRole: "Add Role",
    upRole: "Modify Role",
    roleTypePl: "Please select role type",
    moduleName: "Menu Module",
    checkRender: "Permission List"
  },
  user: {
    userManagement: "User Management",
    globalSearch: "Enter keyword search (user name / role / creator)",
    system: "System",
    resetPassword: "Reset Password",
    userName: "User Name",
    fullName: "Full Name",
    phone: "Phone",
    objectName: "Operator",
    delUserConfirm: "Are you sure to delete the selected user?",
    addUser: "Add Users",
    upUser: "Modify User",
    info: "Essential Information",
    userPwd: "Password",
    confirmPassword: "Confirm Password",
    userPwdNull: "Please input a password",
    userPwdMin: "Password length is 18 ~ 6 characters",
    userPwdError: "The password cannot contain spaces, tabs, or line breaks",
    userPwdTowError:
      "Please confirm whether the old and new passwords are consistent",
    queryUser: "View User",
    userRolePl: "Please select a role",
    newPassword: "New Password"
  },
  log: {
    tab1: "Operation Log",
    tab2: "Login Log",
    loginIp: "Login IP",
    loginTime: "Login Time",
    resultDesc: "Operation Details",
    logGlobalSearch: "Enter keyword search (user name, login IP)",
    operationLogGlobalSearch:
      "Enter keyword search (user name / module name / operation method / client IP)",
    requestIp: "Customer IP",
    moduleName: "Module Name",
    methodDesc: "Operation Method",
    operatorTime: "Operation Time",
    responseCode: "Operation Details"
  },
  onlineuser: {
    globalSearch: "Please enter keywords (username / login / IP address)",
    offline: "Forced Offline",
    offlineConfirm: "Are you sure you want to force logoff?",
    userFullName: "Role Name",
    ipAddress: "IP Address",
    loginTime: "Login Time"
  },
  dictionary: {
    globalSearch: "Enter keyword search (dictionary name)",
    add: "Addendum Items",
    updata: "Modify Items",
    items: "Items",
    child: "Children",
    read: "Read-only",
    addOp: "All Operations",
    edit: "Edit",
    typeName: "Dictionary Name",
    typePkId: "Key Value",
    itemList: "Canonical table item",
    typeFlag: "Canonical entry status",
    typeFlagPl: "Please select the table item status",
    remark: "Remark",
    modifyTime: "Update Time",
    itemsManage: "Items Manage",
    childGlobalSearch: "Enter keyword search(items name)",
    rise: "Rise",
    decline: "Decline",
    itemValue: "Items Name",
    englishName: "Items english name",
    thName: "Items Thai name",
    itemKey: "Key",
    itemKeyPl: "Please select key",
    flag: "State",
    normal: "Normal",
    disable: "Disable"
  },
  systemNotice: {
    add: "Add system upgrade",
    upgradeContent: "System upgrade content",
    upgradeTime: "System upgrade time",
    version: "Version",
    versionPl: "Please enter the version number",
    upgradeContentPl: "Please enter the system upgrade content",
    upgradeTimePl: "Please select the system upgrade time",
    updata: "Modify system upgrade"
  },
  modelFile: {
    add: "Add template file",
    templateFile: "Template File",
    fileName: "File Name",
    pkid: "File primary key",
    createUserId: "Founder",
    createTime: "Creation Time",
    attachmentPkId: "Attachment primary key",
    modifyUserId: "Modifier",
    modifyTime: "Modification Time",
    businessType: "Business Type",
    fileType: "File Type",
    templatePkId: "File template primary key",
    attachmentPkIdPl: "Please upload the template file",
    businessTypePl: "Please enter the business type",
    fileNamePl: "Please enter a file name",
    fileTypePl: "Please select a file type",
    remarkPl: "Please enter comments",
    updata: "Modify template file",
    lang: "Language",
    langPl: "Please select language"
  },
  menuList: {
    roleType: "System",
    child: "Children",
    moduleName: "Menu Name",
    englishName: "Menu English name",
    thailandName: "Menu name in Thai",
    privilegeVoList: "Privilege",
    icon: "Icon",
    sort: "Sort",
    url: "Link",
    activeMenu: "Active Menu",
    hidden: "Hidden",
    cacheName: "Cache Name",
    alwaysShow: "Always Show",
    component: "Component",
    yes: "Yes",
    no: "No",
    componentPl: "Please enter component",
    cacheNamePl: "Please enter cache name",
    moduleNamePl: "Please enter a name",
    englishNamePl: "Please enter your English name",
    thailandNamePl: "Please enter the name of the menu in Thai",
    urlPl: "Please enter a link",
    addChild: "Add Submenu",
    updata: "Modify Submenu",
    add: "Add Menu",
    auto: "Privilege Select",
    addAuto: "Add Privilege",
    privilegePl: "Please select privilege"
  },
  stopReason: {
    allConfig: "Batch Setting",
    add: "Add stop reason",
    stopCode: "Stop Code",
    stopName: "Stop Reason",
    duty: "Responsibility Distribution",
    addRow: "Add a row",
    updata: "Modify stop reason",
    stopCodePl: "Please enter the stop code",
    stopNamePl: "Please enter a stop name",
    responsibilityTypePl: "Please select a responsibility assignment",
    configDataPl: "Please select the data to configure",
    configSuccess: "Configuration Successfully",
    responsibilityType: "Responsibility Distribution"
  },
  alarmSet: {
    allConfig: "Batch Setting",
    add: "Added alarm configuration",
    updata: "Modify the alarm configuration",
    alarmLevel: "Alarm Level",
    alarmType: "Alert Type",
    faultName: "Fault Name",
    faultCode: "Error Code",
    faultTipMsg: "User prompt information",
    type: "Alert Type",
    addRow: "Add a line",
    faultCodePl: "Please enter the fault code",
    faultTipMsgPl: "Please enter user prompt information",
    alarmLevelPl: "Please select an alarm level",
    alarmTypePl: "Please select an alert type",
    configDataPl: "Please select the data to configure",
    configSuccess: "Configuration Successfully",
    solution: "Solution",
    solutionPl: "Please enter a solution",
    faultNamePl: "Please enter a fault name",
    faultEnName: "Fault English name",
    faultEnNamePl: "Please enter English name",
    faultTipEnMsg: "English name prompt",
    faultTipEnMsgPl: "Please enter user prompt information in English"
  },
  kafkaLog: {
    globalSearch: "Enter keyword search (topic)",
    partition: "Partition",
    createTime: "Creation Time",
    startOffset: "Offset Min",
    endOffset: "Offset Max",
    consumption: "Consumption",
    allConsumption: "Bulk Re-consumption",
    allConsumptionConfirm:
      "Are you sure you want to re-consume the selected one??",
    allDel: "Batch Deletion",
    allDelConfirm: "Are you sure you want to delete the selected one?",
    topic: "Topic",
    topicInfo: "Consuming topic information",
    requestParam: "Request Parameter",
    reason: "Error Message"
  },
  orderConfig: {
    allOpen: "Batch Open",
    allOpenConfirm: "Are you sure you want to batch open the selected ones?",
    allClose: "Batch Close",
    allCloseConfirm:
      "Are you sure you want to close the selected ones in bulk?",
    open: "Activated",
    close: "Closed",
    enabled: "Whether to enable verification",
    faultName: "Wrong Name",
    faultCode: "Error Code",
    faultDesc: "Error Brief",
    faultTypeDesc: "Error type description"
  },
  alarmsetting: {
    tab1: "Device Alarm Batch Settings",
    tab2: "Device alarm settings one by one",
    tab3: "SIM traffic alert settings",
    set: "Set Up",
    alarmLevel: "Alarm Level",
    faultCode: "Error Code",
    faultName: "Fault Description",
    flow: "Flow Threshold",
    setLevel: "Set the alarm level",
    alarmLevelName: "Alarm Level"
  },
  ratamanage: {
    tab1: "System Rate Template",
    tab2: "Carrier Rate Template",
    templateName: "Template Name",
    updateTime: "Update Time",
    jian: "Sharp",
    feng: "Peak",
    ping: "Flat",
    gu: "Valley",
    acRate: "AC pile charging rate",
    dcRate: "DC pile charging rate",
    delayRate: "Delay fee rate",
    bindStaNum: "Usage Amount",
    modifyTime: "Creation Time",
    rateDetails: "Rate Details",
    delayRateDetails: "Delay Fee Rate Details",
    slotDelayPrice: "Rate (yuan/minute)",
    ent: "Enterprise",
    bindSta: "Affiliate Site",
    stationName: "Site Name",
    stationAddress: "Site Address",
    index: "Serial Number"
  },
  addRatamanage: {
    feeName: "Template Name",
    rate: "Charging Rate",
    delayFreeMinutes: "Free time (minutes)",
    add: "Add system rate template",
    addOper: "Added carrier rate template",
    feeNamePl: "Please enter a template name",
    acRate: "AC Pile Rate",
    dcRate: "DC Pile Rate",
    delayRate: "Delay fee rate",
    slotFlag: "Electricity price type",
    slotElecPrice: "Electricity Price(yuan)",
    slotServicePrice: "Service Charge(yuan/kWh)",
    timeValue: "Period",
    pricePl: "Please enter a number for the price",
    priceMax: "The current price cannot exceed",
    selectTimePl: "Please select a time to add",
    timeNoSelect: "All 24 hours have been selected and cannot be added",
    timeError: "Time periods overlap, please check",
    timeNoSelectSuccess: "Please select the full 24 hours",
    slotElecPriceMax: "The price of electricity cannot exceed",
    slotServicePriceMax: "The service fee price cannot exceed",
    please: "Please Enter",
    slotDelayPrice: "Rate (yuan/minute)"
  },
  equipmentModel: {
    deviceType: "Equipment Type",
    updateTime: "Update Time",
    globalSearch: "Device Model/manufacturer",
    deviceModelName: "Device Model",
    addSn: "Equipment SN interval",
    number: "Quantity",
    standard: "Standard Information",
    matching: "Optional Information",
    manufacturerName: "Manufacturer",
    delDeviceModelName:
      "Are you sure you want to delete the selected device model?",
    minSelectItem: "Please select at least one item",
    factoryInfo: "Manufacturer Information",
    manufacturerPkId: "Manufacturer's Name",
    matchingAdd: "Optional Additions",
    optionName: "Option Name",
    remark: "Option Description",
    addDeviceModel: "Add device model",
    deviceModelNamePl: "Please enter the device model",
    manufacturerPkIdPl: "Please select manufacturer name",
    optionNamePl: "Please enter an option name",
    isChecked: "Is it standard",
    optionValue: "Fixed Value",
    deviceModelDetails: "Device Model Details",
    updataDeviceModel: "Modify device model",
    optionValueError:
      "The fixed value of the selected standard item cannot be empty",
    deviceTypeInfo: "Model Information",
    deviceTypePl: "Please select device type",
    deviceModelPkIdPl: "Please select device model",
    optionEnName: "English Name",
    optionEnNamePl: "Please enter English name",
    remarkEn: "English option description",
    remarkEnPl: "Please enter an English option description"
  },
  equipmentList: {
    sns: "Device SN",
    snsPl: "Sn, multiple separated by commas",
    allSns: "Batch",
    isBindOper: "Attachment Status",
    projectName: "Attribution Project",
    maintenanceMethodsType: "Maintenance Method",
    export: "Import Device",
    add: "Add Device",
    relation: "Relation",
    disassociate: "Disassociate",
    disassociateConfrim: "Are you sure you want to unlink the selected device?",
    delConfirm: "Are you sure you want to delete the selected device?",
    unattached: "Unattached",
    attached: "Attached",
    serialNumber: "Device SN",
    gunNum: "Muzzle Count",
    belongInfo: "Attachment Information",
    import: "Select import file",
    importTpl: "Import Template",
    importTplDownload: "Import template download",
    total: "Total this time",
    dev: "Device",
    dc: "Dc",
    ac: "Ac",
    protocolPkId: "Protocol",
    protocolPkIdPl: "Please select an agreement",
    detailsTitle: "Device Details",
    dataDetails: "Parameter Details",
    manufacturerName: "Manufacturer",
    typeNumber: "Model number of devices",
    changeModel: "Change Model",
    bindDev: "Associated Devices",
    unBindDev: "Device to be associated",
    changeOper: "Change Carrier",
    noChangeOper: "Equipment to be replaced",
    bindOper: "Affiliated Operator",
    operPl: "Please select an operator",
    deviceModelPl: "Please select a device",
    addSn: "Equipment SN interval",
    quantity: "Quantity",
    addBtn: "Add",
    snNull: "Device SN cannot be empty",
    snInt: "Device SN must be a number",
    // 修改密码
    editPwd: "Change Password",
    selectStation1: "Selected ",
    selectStation2: " charging piles",
    customPassword: "Custom Password",
    customPasswordTip: "Set the same password for the selected charging piles",
    randomPassword: "Random Password",
    randomPasswordTip:
      "Automatically generate a random 6-digit password for each charging pile",
    pwdPl: "Please enter an 4-8 digit numeric password.",
    pwdSucc: "Operation successful. Please wait 3 minutes for the results",
    passwordModificationRecord: "Password change history (latest 5)",
    currentPassword: "Current Password",
    password: "Password",
    updateTime: "Update Time",
    status: "Status",
    lastSuccessful: "Last successful password changed"
  },
  producer: {
    busLicenseNumber: "Business license number",
    brandName: "Brand Name",
    manufacturerName: "Equipment Manufacturer",
    manufacturerId: "Equipment Manufacturer Organization Code",
    contactName: "Contact",
    phoneNo: "Phone",
    legalPerson: "Corporate",
    legalIdCard: "Legal person ID",
    busLicenseNumberPl: "Please enter the business license number",
    busLicenseNumberMax:
      "The length of the business license number is 18 digits",
    brandNamePl: "Please enter a brand name",
    manufacturerNamePl: "Please enter device manufacturer",
    manufacturerIdPl: "Please enter the device manufacturer organization code",
    manufacturerIdMax:
      "The length of the business license number is nine digits",
    legalPersonPl: "Please enter company legal person",
    legalIdCardPl: "Please enter legal person ID",
    legalIdCardMax: "The length of the legal person ID card is 18 characters",
    contactNamePl: "Please enter a contact",
    add: "Add equipment manufacturers",
    updata: "Modify device manufacturer"
  },
  oper: {
    "101": "Login SMS Template",
    "102": "Modify password template",
    "103": "Information Change Template",
    "104": "Authentication Template",
    "201": "Charging start notification",
    "202": "Charge settlement notice",
    "203": "Charging end notification",
    "204": "Insufficient balance reminder",
    "301": "Failure Notification",
    operData: "Number of operators",
    operTotal: "Total number of operators",
    accData: "Account Expiration Analysis",
    globalSearch: "Enter keyword search (operator name/operator abbreviation)",
    oprStatus: "Operational Status",
    expireDays: "Date of Expiry",
    customMade: "Custom Made",
    msgConfig: "SMS Config",
    phoneConfig: "Custom Config",
    functionalConfig: "Functional configuration",
    gunLimit: "Gun Limit",
    invoice: "Invoice",
    carInfo: "Vehicle Information",
    customizedChargingStrategy: "Customized Charging Strategy",
    day30: "30 days due",
    day60: "60 days due",
    day90: "90 days due",
    companyName: "Short Name",
    userName: "Admin",
    deviceCount: "Equipment Quantity",
    createTime: "Create Time",
    delOper: "Are you sure you want to delete the carrier?",
    expireTime: "Expire Date",
    msgServer: "SMS Service",
    agent: "SMS service provider",
    pilot: "CS Enegy",
    operMsg: "Operator Owned",
    signName: "SMS Signature",
    agentPl: "Please select an agent",
    signNamePl: "Please enter a signature",
    please: "Please Enter",
    addOper: "Carrier basic information",
    operatorId: "Organization Code",
    operMax: "Please enter no more than 30 characters",
    companyNameMax: "Within 10 characters",
    address: "Address",
    addressPl: "Please enter detailed address",
    region: "region",
    addressPlCity: "Please select region",
    description: "Company Description",
    contactPerson: "Contact",
    tel: "Contact Number",
    serviceTel: "Consumer Hotline",
    contactsMail: "Contact Email",
    oprSystemName: "Carrier System Name",
    oprSystemLogoFilePath: "System LOGO",
    operTime: "Operation Period",
    activeTime: "Effective Time",
    allTime: "Permanent",
    add: "Add Operator",
    updata: "Updata Operator",
    query: "View Operator",
    rolePkIdPl: "Please select an operator role",
    oprSystemLogoFilePathPl: "Please upload the operator system logo",
    qrCodeFilePathPl: "Please upload the QR code",
    mchCertFilePathPl: "Please upload a request for a refund certificate",
    logoPl: "Please upload logo",
    activeTimePl: "Please select the effective time",
    zfbNamePl: "Please enter SMS signature",
    customTitle: "Custom Function",
    gunQrCodeType: "QR code link of charging pile muzzle",
    gunQrCodeTypePl: "Please choose the type",
    gunQrCodeType1: "Interconnection",
    gunQrCodeType2: "Public account link method",
    gunQrCodeTypeTextP1:
      "1. After the operator creates it, configure the custom function separately",
    gunQrCodeTypeTextP2:
      "2. The default interconnection mode of the muzzle QR code, that is, the current QR code mode",
    gunQrCodeTypeTextP3:
      "3. The link method of the official account is to scan the QR code of the muzzle with the link mode of the official account",
    accTime: "Account Expiration Analysis",
    loginInfo: "Carrier login information",
    loginUrl: "Login Information",
    loginName: "Login Account",
    loginPasswd: "Login Password",
    tips:
      "Note: Please save your login information, if you forget your password, please click reset;",
    resetPassword: "Reset Password",
    close: "Close",
    copy: "Quick Copy",
    loginPassword: "Login Password",
    iosAppDownloadLink: "IOS APP Download Link",
    androidAppDownloadLink: "Android APP Download Link",
    website: "Company Website",
    creditPayment: "Credit Payment",
    valueAddedFeatures: "Value-added features",
    notificationMethodUser: "Notification method for individual users",
    notificationMethodOperatorsser: "Notification method for operators",
    passwordVerificationForOperatorModification:
      "Password verification for operator modification",
    registrationAndLoginConfiguration: "Registration and login configuration",
    verificationMethod:
      "Verification method (register/forget password/change password)",
    registrationsSkipPasswordSetting:
      "Can new registrations skip password setting?",
    passwordLoginMethod: "Password login method",
    prioritySMS: "Priority SMS",
    priorityEmail: "Priority Email",
    SMS: "SMS",
    email: "Email",
    passwordVerification: "Password Verification",
    sMSVerification: "SMS Verification",
    sMSVerificationCode: "SMS Verification Code",
    emailVerificationCode: "Email Verification Code",
    phoneNumberPassword: "Phone Number Password",
    emailPassword: "Email Password",
    verificationCodeLogin: "Verification Code Login",
    PasswordLogin: "Password Login",
    rechargeCashier: "Recharge Cashier",
    selfBuiltCashRegiste: "Self-built Checkout",
    hirdPartyCashRegister: "Third-party Checkout",
    cash: "Cash",
    paymentChannel: "Payment Method",
    paymentChannelPl: "Please select  payment method",
    channelPartners: "Channel Partner",
    channelPartnersPl: "Please select channel partner",
    plugAndCharge: "Plug & Charge",
    creditCard: "Credit/Debit Card"
  },
  operAccount: {
    reconciliation: "Manual Reconciliation",
    abnormalSum: "Number of exceptions",
    result: "Reconciliation Result",
    accDetails: "Account Details",
    details: "Reconciliation Details",
    formula: "Compare Accounts",
    abnormalReason: "Comparison Details",
    leftAmount: "Money on the left",
    rightAmount: "Money on the right",
    money: "Difference",
    accountType: "Account Type",
    accountPkId: "Account Number",
    balanceAmount: "Balance",
    orderNo: "Charging order number",
    orderNoPl: "Please enter charging order number",
    userCorrectAmount: "Personal user account offset amount",
    userCorrectAmountPl: "Please enter the personal user account offset amount",
    prepayCorrectAmount: "Escrow account offset amount",
    prepayCorrectAmountPl: "Please enter the escrow account offset amount",
    chargeCorrectAmount: "Charge account offset amount",
    chargeCorrectAmountPl: "Please enter the charging account offset amount",
    password: "Operation Password",
    passwordPl: "Please enter the operation password"
  },
  postNotice: {
    globalSearch: "Title fuzzy search",
    publish: "Publish",
    publishConfirm: "Are you sure you want to publish?",
    withdraw: "Withdraw",
    withdrawConfirm: "Are you sure you want to withdraw?",
    title: "Title",
    titlePl: "Please enter a title",
    content: "Content",
    contentPl: "Please enter content",
    createTime: "Creation Time",
    publishTime: "Release Time",
    publishStatus: "Post Status",
    email: "E-mail Notification",
    emailPl: "Please select email notification",
    open: "Open",
    close: "Close",
    add: "Add Publish",
    operPl: "Please select an operator",
    details: "Publish Details",
    updata: "Updata Publish"
  },
  auditHlhtSystem: {
    netDriection: "Interconnection Direction",
    netStatus: "Approval Status",
    globalSearch: "Keywords",
    netFileName: "Download Attachments",
    audit: "Audit",
    auditModal: "Audit Interconnection",
    yes: "Pass",
    no: "Fail",
    systemName: "System Name",
    reason: "Reason for Application",
    netType: "Interworking Type",
    beginTime: "Start Time",
    endTime: "End Time",
    contactName: "Contact",
    phoneNo: "Phone"
  },
  addValueService: {
    serviceName: "Service Name",
    logo: "Service Logo",
    hasOpen: "Open State",
    add: "Add value-added services",
    enable: "Enable",
    disabled: "Disabled",
    logoPl: "Please upload file",
    hasOpenPl: "Please select a status"
  },
  dataConfig: {
    tab1: "Electricity bill configuration",
    tab2: "QR code configuration",
    connectLoading: "Connecting.....",
    connectClose: "The connection was interrupted or the connection was closed",
    reconnect: "Reconnect",
    realTimeMsg: "Real-time Message",
    clear: "Clear",
    gunPkIdPl: "Please select a muzzle",
    subscribeSuccess: "Subscription Succeeded",
    pilePkId: "Pile Number",
    pilePkIdPl: "Please select pile",
    gunPkId: "Gun Number",
    ratedVoltage: "Rated Voltage",
    ratedCurrent: "Rated Current",
    ratedPower: "Equipment Power",
    reply: "Reply",
    get: "Get",
    pile: "Pile",
    platform: "Platform",
    pileData: "Pile Data",
    platformData: "Platform Data",
    rateName: "QR Code",
    rateNamePl: "Please enter the QR code string",
    getBtn: "Recall Test",
    issue: "Issue QR code",
    send: "Send",
    clickSend: "Click to send",
    response: "Response",
    issueSuccess: "Issued Successfully",
    ratePkid: "Rate",
    rateTpl: "Rate Template Name",
    acRate: "AC Pile Rate",
    pileRate: "Pile Rate",
    platformRate: "Platform Rate",
    slotFlag: "Price Type",
    slotElecPrice: "Electricity Price(yuan/kWh)",
    slotServicePrice: "Service Charge(yuan/kWh)",
    time: "Period"
  },
  chargingOperation: {
    status1: "Idle",
    status2: "Gun Inserted",
    status3: "Start Charging",
    status4: "Charging",
    status5: "Undrawn Gun",
    tab1: "Charging report data",
    tab2: "BMS reporting data",
    tab3: "Charging report data",
    startCharging: "Start Charging",
    msgType1: "Real Time",
    msgType2: "History",
    time: "Communication Time",
    loadMore: "Load More"
  },
  operData: {
    "58": "Multi-rate unit price version number",
    "100": "Networking",
    "202": "Upgrade package version",
    "513": "SIM card ICCID",
    "1003": "Disable/Allow offline charging",
    "1007": "Maximum charging current",
    "1009": "Maximum charging power",
    "1010": "QR Code",
    "2024": "SIM card signal strength",
    tab1: "Device Login",
    tab2: "Device Heartbeat",
    tab3: "Fault Report",
    tab4: "Upgrade",
    upgrade: "Upgrade",
    sendSuccess: "The command has been sent, check the device status",
    allow: "Allow",
    prohibit: "Prohibit",
    ethernet: "Ethernet",
    host: "Host ip address",
    port: "Host Port",
    userName: "FTP Username",
    password: "FTP user password",
    fileDir: "File Directory",
    success: "Update Successed"
  },
  messageManage: {
    msgTitle: "SMS Pool",
    rechange: "Rechange",
    remaining: "Remaining available number(s)",
    used: "Number of used bars (bars)",
    top5: "Remaining available top5",
    unit: "Strip",
    remainingMin: "Remaining Min",
    remainingMax: "Remaining Max",
    usedMin: "Min Used",
    usedMax: "Max Used",
    recordBtn: "SMS Record",
    rechargeBtn: "SMS Recharge",
    totalNum: "Purchased",
    sentNum: "Used Bars",
    addNum: "Add SMS",
    remainNum: "Remaining Messages",
    comboPkId: "Buy SMS",
    paymentAmount: "Payment Amount",
    msgRechange: "SMS Recharge",
    comboPkIdPl: "Please select the number of SMS"
  },
  messageRecord: {
    tab1: "Purchase Record",
    tab2: "Send Record",
    pkid: "Order Number",
    purchasedWay: "Ways to purchase",
    auditStatus: "Order Status",
    attachmentUrl: "Appendix",
    downloadAttachmentUrl: "Download",
    audit: "Audit",
    createUserName: "Operator",
    purchasedCount: "Purchase Quantity",
    paymentAmount: "Payment Amount",
    createTime: "Purchase Time",
    phoneNo: "Phone",
    agent: "Send Type",
    bussType: "Business Type",
    pilot: "CS Enegy",
    aliCloud: "Ali Cloud",
    sendTime: "Send Time",
    content: "Send Content",
    status: "Send Status",
    auditAction: "Approval Status",
    oprSystemLogoFilePath: "Upload Attachment",
    msgAudit: "SMS Audit",
    auditActionPl: "Please select a review status",
    oprSystemLogoFilePathPl: "Please upload attachment",
    auditAction1: "Pass",
    auditAction2: "Refuse"
  },
  messagePrice: {
    number: "Number of SMS",
    price: "Package Price",
    contactPhone: "Contact phone number",
    status: "State",
    rechargeContact: "Top-up Contact",
    rechargeTips:
      "Modifying the contact information will synchronously modify the contact information of other SMS packages, please modify with caution",
    qrCodeFilePkId: "Contact WeChat",
    qrCodeFilePkIdTips: "Upload QR code, support .jpg .jpeg .png",
    qrCodeFilePkIdPl: "Please upload contact WeChat",
    updata: "Modify Pricing",
    add: "Add Pricing",
    close: "Closure",
    closeConfirm: "Are you sure about closing?"
  },
  cardClient: {
    projectName: "Project Name",
    updataTime: "Update Time",
    queryCode: "View customer code",
    licenseBtn: "License Management",
    createUserName: "Founder",
    activatedAmount: "Number of activated",
    projectCode: "Customer Code",
    modifyTime: "Download license file",
    moduleNames: "Licence Module",
    machineCode: "Serial Number",
    pileNumber: "Number of piles",
    status: "Status",
    beginTime: "Effective Date",
    endTime: "Expire Date",
    add: "Add Item",
    projectNamePl: "Please enter a project name",
    projectCodeMax: "Client code must be 8 digits",
    modulePkIdsPl: "Please select Licence module",
    machineCodePl: "Please enter serial number",
    beginTimePl: "Please select an effective date",
    endTimePl: "Please select an expiration date",
    addLicence: "Add Licence",
    updataLicence: "Updata Licence",
    timeMax: "Effective date cannot exceed expiration date"
  },
  simOutTest: {
    projectName: "Project Name",
    keywords: "Keywords",
    pileNoOrIccidPl: "Device ID/ICCID",
    applicantOrCaller: "Claimant/caller",
    simStatus: "SIM card status",
    createTime: "Creation Time",
    recallTest: "SIM card test",
    claim: "SIM card application",
    batchSync: "Batch Sync",
    sync: "Synchronize",
    applicant: "Claimant",
    caller: "Call Tester",
    outgoer: "Seller",
    modifyTime: "Update Time",
    simStatusPl: "Please select SIM card status",
    serialNumber: "Device ID",
    applyTitle: "Apply for a SIM card",
    iccid: "SIM card number",
    iccidTips: "Please enter, limit 100 characters",
    importFile: "Importing Files",
    downloadTpl: "Download Template",
    simSum: "Number of SIM cards",
    applicantPl: "Please enter the claimant",
    iccidPl: "Please enter SIM card number",
    outgoerPl: "Please enter the sender",
    snStartNo: "Enter start number",
    snEndNo: "Enter end number",
    match: "Match",
    projectNamePkId: "Associated Project",
    saveExport: "Save and export",
    modalTitle: "SIM card test"
  },
  productionOrder: {
    step0: "Process Starts",
    step1: "First Step",
    step2: "Second Step",
    step3: "Third Step",
    step4: "Process Ends",
    content0: "Add task list",
    content1: "Start Production",
    content2: "Equipment Storage",
    content3: "Quality Inspection",
    content4: "Equipment Delivery",
    keyword: "Keywords",
    numOrProject: "Contract number/project name",
    modelName: "Device Model",
    productionStatus: "Manufacturing State",
    createTime: "Date Created",
    syncDev: "Sync Device",
    start: "Start Production",
    void: "Void",
    changePriority: "Adjust Priority",
    warehousing: "Equipment Storage",
    check: "Quality Check",
    ship: "Equipment Delivery",
    index: "Serial Number",
    priority: "Priority",
    orderType: "Task order type",
    contractBillNumber: "Contract Number",
    projectName: "Project Name",
    platformModel: "Platform Model",
    pileNum: "Equipment Quantity",
    doneModelNum: "Shipped",
    warehousingConfirm: "Are you sure you want to stock up??",
    delConfirm: "Are you sure you want to delete this production order?",
    voidConfirm: "Are you sure you want to void the production order??",
    startConfirm: "Are you sure you want to start production??",
    projectInfo: "Project Information",
    contractBillNumberPl: "Please select the contract number",
    priorityPl: "Please select a priority",
    projectNamePl: "Please select a project name",
    devInfo: "Device Information",
    materialNumber: "Material Code",
    materialNumberPl: "Please enter the finished product code",
    clientNum: "Customer Code",
    clientNumPl: "Please enter customer code",
    deviceModelPkId: "Device Model",
    deviceModelPkIdPl: "Please select device model",
    platformModelPl: "Please select a platform model",
    deviceNo: "Device ID",
    deviceStartNo: "Start device number",
    deviceEndNo: "End device number",
    quantity: "Equipment Quantity",
    motherboard: "Motherboard",
    motherboardPl: "Please enter the motherboard",
    interfaceBoard: "Interface Version",
    interfaceBoardPl: "Please enter the interface version",
    displayScreen: "Display",
    displayScreenPl: "Please enter the display",
    requirements: "Customization and Production Requirements",
    requirementsPl: "Please enter custom and production requirements",
    inputMaxPl: "Please enter, limit 100 characters",
    equipmentRemarks: "Equipment Notes",
    equipmentRemarksPl: "Please enter device remarks",
    adds: "Keep Adding",
    issuerAndCard: "Card issuer + IC card",
    issuerAndCardPl: "Please enter the card issuer + IC card",
    remark: "Task list remarks",
    remarkPl: "Please enter a task note",
    verificationInfo: "Inspection Information",
    verifier: "Inspector",
    checkContent: "Check Content",
    shippingInfo: "Shipping Information",
    deliveryRequirements: "Shipping Requirements",
    logisticsAndNumber: "Logistics and tracking number",
    inspectionAndSignature: "Inspection and shipment inspection signature",
    shippingCardIssuerICCard: "Card issuer + IC card",
    shippingCardIssuerICCardPl: "Please enter the card issuer + IC card",
    orderTypePl: "Please select a task order type",
    add: "Add task list",
    updata: "Modify task list",
    details: "Task Order Details",
    other: "Other Information",
    deliveryRequirementsPl: "Please enter shipping request",
    logisticsAndNumberPl: "Please enter the logistics and tracking number",
    inspectionAndSignaturePl:
      "Please enter the signature for inspection and shipment inspection",
    verifierPl: "Please enter the verifier",
    checkContentPl: "Please enter the verification content"
  },
  salesOrder: {
    globalSearch: "Contract number / project name / salesperson",
    sellerName: "Seller",
    specificationModel: "Specifications",
    month: "Estimated Delivery",
    monthPl: "Please select estimated delivery",
    deliveryTime: "Delivery Time",
    shipConfirm: "Are you sure you want to ship?",
    childTitle: "Sub-items - Product Information",
    number: "Quantity",
    requirementDesc: "Description of Requirement",
    requirementDescPl: "Please enter a requirement description",
    shippingAddress: "Delivery Address",
    shippingAddressPl: "Please enter shipping address",
    add: "Add sales order",
    contractBillNumberPl: "Please enter the contract number",
    specificationDetails: "Specification",
    specificationDetailsPl: "Please enter the specification",
    sellerNamePl: "Please enter salesperson",
    month1: "January",
    month2: "February",
    month3: "March",
    month4: "April",
    month5: "May",
    month6: "June",
    month7: "July",
    month8: "August",
    month9: "September",
    month10: "October",
    month11: "November",
    month12: "December"
  },
  header: {
    clickGo: "Click to jump",
    out: "Sign Out",
    outConfirm: "Are you sure you want to log out?",
    unit: ""
  },
  reportFile: {
    pageTitle: "Report File",
    deviceArchivePkId: "File ID",
    deviceTypeName: "Equipment Type",
    manufacturerName: "Manufacturer",
    deviceModelName: "Equipment Model",
    deviceModelRatedPower: "Rated Power",
    deviceModelChargeStandardName: "Equipment Standards",
    archiveCode: "Report No",
    feelerMechanismName: "Testing Agency",
    archiveCreateDate: "Report generation date",
    attachmentRecordPkId: "Type test report",
    entryDate: "Entry Date",
    deviceRatedPower: "Power Range(kW)",
    query: "Click to view",
    change: "Change Report",
    updataTitle: "Please select a file",
    minDeviceRatedPowerError:
      "The minimum value of power range cannot be less than 0",
    maxDeviceRatedPowerError:
      "The maximum value of power range cannot be less than 0",
    minMaxDeviceRatedPowerError:
      "The maximum value of power range cannot be less than the minimum value"
  },
  siteSizeConfig: {
    smallSizeStaNum: "Small-scale",
    mediumSizeStaNum: "Medium Scale",
    largeSizeStatNum: "Large-scale",
    configName: "Configuration Name",
    pileNum: "Number of piles (set)",
    power: "Power (kw)",
    min: "Less Than",
    max: "Greater Than",
    updataTitle: "Modify site size configuration",
    maxTips: "The maximum value cannot be less than:",
    maxPile: "Maximum value of pile",
    minPile: "Minimum value of pile",
    maxPower: "Maximum Power",
    minPower: "Minimum Power"
  },
  appUpdate: {
    addUpgradeReminder: "Add Upgrade Reminder",
    editUpgradeReminder: "Edit Upgrade Reminder",
    operatorNameAbbreviation: "Operator Name/Abbreviation",
    type: "Type",
    status: "Status",
    upgradeCopy: "Upgrade Copy",
    thaiLanguage: "Thai Language",
    english: "English",
    chinese: "Chinese",
    inValidContent: "Will Continuing Invalidate This Rule?",
    msg: {
      error:
        "An Operator Rule of the Same Type is Currently Effective, Please Invalidate the Original Rule First"
    },
    table: {
      compatibleOperator: "Compatible Operator",
      type: "Type",
      mandatoryUpgradeVersion: "Mandatory Upgrade Version",
      remindUpgradeVersion: "Upgrade Reminder Version",
      remarks: "Remarks",
      updateTime: "Update Time",
      status: "Status",
      operation: "Operation",
      addUpgradeNotification: "Add Upgrade Notification",
      effective: "Effective",
      ineffective: "Ineffective",
      pendingActivation: "Pending Activation"
    },
    rules: {
      appType: "Please Select Phone Type",
      oprType: "Please Select Operator",
      remindUpgradeVersion: "Please Enter Upgrade Reminder Version Number"
    }
  },
  paymentChannel: "Pay Method",
  car: {
    addModel: {
      addTitle: "add car",
      editTitle: "edit car"
    },
    tips: {
      brandTips: "brand is required",
      serialTips: "serial is required",
      modelTips: "model is required",
      fuelTypeTips: "fuelType is required"
    },
    operator: "Operator",
    timeSubmitted: "Time Submitted",
    carDirectory: "Car Directory",
    userFeedback: "User Feedback",
    brand: "Brand",
    series: "Series",
    model: "Model",
    region: "Region",
    powerMode: "Power Mode",
    rank: "Rank",
    type: "type",
    seats: "Seats",
    batteryCapacity: "Battery Capacity (kWh)",
    mileage: "Mileage (km)",
    createDate: "Create Date",
    users: "Number of Users",
    inputLimitDescription: "Enter up to 4 digits, with 2 decimal places",
    inputPositiveInteger6DigitsMax:
      "Please enter a positive integer up to 6 digits",
    globalSearch: "Enter Car Model"
  },
  countrycode: {
    add: "Add Area Code",
    edit: "Edit Area Code",
    areaCode: "Area Code",
    enName: "English Name",
    zhName: "Chinese Name",
    locName: "Local Language Name",
    regRules: "Regular Expression Validation Rules",
    regRulesPl: "Please enter regular expression validation rules",
    regRulesPl1: "Please enter the correct regular expression validation rules"
  }
};
